import React from 'react';
import styles from './AcceptTermsInput.module.css';

import tick from '../../assets/img/white-tick.svg';

export default props => {
  const {
    name,
    label,
    onClick,
    active,
    setViewTerms,
    customThemeBaseColor,
    declineTerms
  } = props;

  const mobileInputButtonStyle = {};

  if (active) {
    mobileInputButtonStyle.backgroundColor = customThemeBaseColor || '#dccbfd';
  } else {
    mobileInputButtonStyle.backgroundColor = customThemeBaseColor
      ? `${customThemeBaseColor}30`
      : '#f9f7ff';
  }

  return (
    <div
      className={
        active
          ? `${styles.acceptInputContainer} ${
              styles.acceptInputContainerActive
            } accept-input-${name}`
          : `${styles.acceptInputContainer} accept-input-${name}`
      }
    >
      <div
        className={
          declineTerms
            ? `${styles.hideOnMobile} ${styles.desktopInput}`
            : styles.desktopInput
        }
      >
        <div
          className={styles.checkmark}
          style={
            active
              ? { backgroundColor: customThemeBaseColor || '#5200f1' }
              : null
          }
          role="presentation"
          onClick={() => onClick()}
        >
          {active ? (
            <img src={tick} alt="Tick" className={styles.tick} />
          ) : null}
        </div>
        <div className={styles.termsText}>
          {declineTerms ? (
            <span>{label.I_AM_NOT_INTERESTED}</span>
          ) : (
            <>
              {label.I_AM_AWARE_OF_THE}{' '}
              <span
                role="presentation"
                className={styles.termsLink}
                style={{ color: customThemeBaseColor || '#5322f3' }}
                onClick={() => setViewTerms(true)}
              >
                {label.TERMS_AND_CONDITIONS}
              </span>{' '}
              <span className={styles.desktopAgreement}>
                {label.AND_AGREE_BY_CHECKING_THIS_BOX}
              </span>
              <span className={styles.mobileAgreement}>
                {label.AND_CONFIRM_I_AGREE}
              </span>
            </>
          )}
        </div>
      </div>
      <div
        role="presentation"
        className={styles.mobileInputButton}
        style={mobileInputButtonStyle}
        onClick={() => onClick()}
      >
        {declineTerms ? label.I_AM_NOT_INTERESTED : label.I_AGREE}
      </div>
    </div>
  );
};
